import { Question } from '@modules/HappinessModule/interfaces/question';
import { createAction } from '@reduxjs/toolkit';
import { QuestionsAsync } from './types';

export const getQuestions = createAction<void>('questions/getQuestions');
export const setQuestions = createAction<QuestionsAsync>('questions/setQuestions');
export const setLoadingData = createAction<void>('questions/setLoadingData');
export const setSelectedQuestion = createAction<Question | undefined>('questions/setSelectedQuestion');
